module.exports = __webpack_public_path__ + "assets/img/footer3.53b9ee07.png";